// Helpers del avatar: iniciales y color por nombre.

const AVATAR_COLORS = ['#1c8ee0', '#2c8af8', '#18ce0f', '#ff8d72', '#fb404b', '#9b51e0', '#56ccf2', '#f5a623'];

export const buildInitials = (u) => {
  const f = (u && (u.first_name || u.firstName) || '').trim().charAt(0);
  const l = (u && (u.last_name  || u.lastName)  || '').trim().charAt(0);
  return ((f + l).toUpperCase()) || '?';
};

export const colorFromString = (s) => {
  if (!s) return AVATAR_COLORS[0];
  let h = 0;
  for (let i = 0; i < s.length; i++) h = ((h << 5) - h) + s.charCodeAt(i);
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
};

export const userAvatarBg = (u) =>
  colorFromString(((u && u.first_name) || '') + ((u && u.last_name) || ''));

export const userHasPicture = (u) => !!(u && (u.profile_picture || u.avatar));

export const userPictureUrl = (u) => (u && (u.profile_picture || u.avatar)) || null;

// Lee firstName/lastName en cualquiera de los dos formatos (camelCase del profile
// schema o snake_case si alguna respuesta legacy lo tiene).
export const userFirstName = (u) => (u && (u.firstName || u.first_name)) || '';
export const userLastName  = (u) => (u && (u.lastName  || u.last_name))  || '';
export const userFullName  = (u) => `${userFirstName(u)} ${userLastName(u)}`.trim();
